import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const classTypes = [
  {
    icon: 'ri-translate-2',
    title: 'Escolas de Idiomas',
    description: 'Múltiplos professores de idiomas diferentes no mesmo espaço. Inglês no canal 1, espanhol no canal 2, francês no canal 3 — cada aluno ouve apenas seu professor. Otimização total do espaço físico.',
    highlight: '3 idiomas simultâneos',
    image: '/img/stib/setor-educacao.webp',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Aulas de Fitness Coletivo',
    description: 'Vários instrutores de modalidades diferentes na mesma academia. Spinning, yoga, alongamento e funcional acontecendo simultaneamente — cada aluno no canal do seu treino, sem poluição sonora cruzada.',
    highlight: '4+ modalidades no mesmo espaço',
    image: '/img/stib/setor-educacao.webp',
  },
  {
    icon: 'ri-building-line',
    title: 'Treinamentos Corporativos',
    description: 'Múltiplos workshops simultâneos em eventos corporativos. Liderança no canal 1, vendas no canal 2, compliance no canal 3. Cada colaborador escolhe a trilha que mais interessa — no mesmo salão, ao mesmo tempo.',
    highlight: 'Multi-trilhas simultâneas',
    image: '/img/stib/fone-treinamento.webp',
  },
  {
    icon: 'ri-store-line',
    title: 'Feiras e Eventos Educacionais',
    description: 'Estantes e palcos próximos sem conflito de áudio. Cada expositor ou palestrante transmite em seu canal. Os visitantes circulam livremente e escolhem qual conteúdo ouvir — experiência imersiva sem poluição sonora.',
    highlight: 'Estantes sem interferência',
    image: '/img/stib/setor-feira.webp',
  },
  {
    icon: 'ri-mental-health-line',
    title: 'Yoga e Meditação Guiada',
    description: 'Instrutor conduz a prática com voz suave diretamente no ouvido de cada aluno. Sem ruído externo, sem distrações. A imersão sonora potencializa o relaxamento e a concentração — experiência de spa em qualquer ambiente.',
    highlight: 'Imersão total no áudio',
    image: '/img/stib/setor-educacao.webp',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Aulas de Culinária e Workshops',
    description: 'Vários chefs ensinando receitas diferentes no mesmo espaço. Cozinha italiana no canal 1, japonesa no canal 2, confeitaria no canal 3. Os alunos ouvem apenas seu instrutor — sem o ruído de panelas e conversas dos outros grupos.',
    highlight: 'Múltiplos chefs, zero ruído',
    image: '/img/stib/setor-educacao.webp',
  },
];

export default function ClassTypesSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Aplicações
          </span>
          <h2
            className={`font-heading font-bold text-5xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            para qual tipo de aula
          </h2>
          <p
            className={`font-body text-xl text-gray-500 max-w-2xl mx-auto transition-all duration-700 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            A tecnologia de aula silenciosa se adapta a qualquer formato de ensino — da sala de idiomas ao festival de wellness
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {classTypes.map((item, i) => (
            <article
              key={i}
              className={`group bg-white border border-gray-100 rounded-3xl overflow-hidden hover:border-primary/30 hover:-translate-y-1 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={`Aula silenciosa em ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10">
                    <i className={`${item.icon} text-primary text-xl`} />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-secondary">{item.title}</h3>
                </div>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">{item.description}</p>
                <div className="inline-flex items-center gap-2 bg-primary/8 rounded-full px-4 py-2">
                  <i className="ri-check-line text-primary text-sm" />
                  <span className="font-body text-xs font-semibold text-primary">{item.highlight}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}